'use client';

/**
 * Content Assistant — agentic chat embedded in the Content section.
 *
 * Boss talks to the content engine here instead of the main Chat: ideas,
 * scripts, hooks, captions, the creation pipeline, queue/publishing state.
 * Runs a dedicated gateway session (`content-asst`) with cwd ~/beast so the
 * agent can read the content DB/API and the script-writer skill.
 *
 * Model policy (Boss, 2026-07-04): default chat model is Fable 5
 * (claude-fable-5 — set as gateway defaultModel); image generation is
 * always GPT Image 2.0 (OpenAI `gpt-image-2`, via factory gpt-image-mockup.sh
 * or /v1/images/generations).
 */
import { AssistantShell } from '@/components/chat/AssistantShell';

const SUGGESTIONS = [
  'Give me 5 content ideas for this week',
  'Write a 30-second reel script with a strong hook',
  'What is sitting in the publish queue right now?',
  'Generate an image concept for the next post (GPT Image 2.0)',
];

function buildGrounding(): string {
  return [
    'You are the Content Assistant inside the Beast dashboard — a senior content strategist + copywriter for Boss\'s businesses (WTF web-services sites, Olga ERM funnel, collaborations). Be concise, specific, actionable; short markdown.',
    '',
    'You can inspect the live content system on this machine:',
    '- Content library/queue API: `curl -s "http://localhost:3000/api/content"` and `/api/content/publish` (GET = queue state).',
    '- The script-writer skill: read ~/.soma or ~/beast/.soma skills `script-writer` for the house method (hooks, shot lists, captions).',
    '- Revoice pipeline: ~/beast/scripts/revoice.sh; Video Lab: /api/funnels/videolab/*.',
    '',
    'Model policy: image generation is ALWAYS GPT Image 2.0 (OpenAI model id `gpt-image-2`) — never DALL-E or Gemini. For image tasks, produce the exact prompt and offer to run ~/beast/factory/scripts/gpt-image-mockup.sh.',
    'Nothing publishes without Boss\'s explicit approval — you may draft and queue, never auto-publish.',
  ].join('\n');
}

export function ContentAssistant() {
  return (
    <AssistantShell
      slug="content-asst"
      sessionName="Content Assistant"
      sessionIcon="📣"
      title="Content Assistant"
      subject="content engine"
      emptyGradient="from-pink-500 to-violet-600"
      emptyBlurb="Ideas, scripts, hooks, captions, queue state — ask me anything about the content pipeline."
      suggestions={SUGGESTIONS}
      buildGrounding={buildGrounding}
      confirmClearText="Clear the content assistant chat and start fresh?"
    />
  );
}
